import React, { useEffect, useRef, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { AnswerItem, FormShowType, QuestionTypes, ReduxState } from 'interface';
import { QuestionSLPRef, SLPQuestionType } from '../../questions.index';
import { urlValidation } from 'scripts/validation';
import SLPInputUrl, { SLPInputURLRef } from 'utilities/slp/inputUrl/inputUrl.index';
import { extractTitle } from 'scripts/string';
import { createQuestionTitle } from '../questionsTypes.script';
import { getQuestionBadge } from 'data/questionsBadge';

const SLPWebsiteQuestion: React.ForwardRefRenderFunction<
    QuestionSLPRef,
    ConnectedProps<typeof connector> & SLPQuestionType
> = (props: ConnectedProps<typeof connector> & SLPQuestionType, ref) => {
    React.useImperativeHandle(ref, () => ({
        validate: (e?: boolean) => validate(e),
        submit: (e?: boolean) => onSubmit(e),
    }));
    const lang = props.lang.SLP.questionsTypes;
    const question = props.question;
    const inputRef = useRef<SLPInputURLRef>(null);
    const [title, setTitle] = useState(question.title);
    const index = props.answerList?.findIndex((i) => i.question.id === question.id);

    const [hint, setHint] = useState(question.description);

    useEffect(() => {
        if (question.description)
            setHint(
                createQuestionTitle(
                    question.description,
                    props.answerList,
                    props.answer?.answerer_info,
                    props.form.indicators,
                ),
            );
        setTitle(
            createQuestionTitle(question.title, props.answerList, props.answer?.answerer_info, props.form.indicators),
        );
    }, [props.answerList]);

    function validate(e?: boolean) {
        const value = inputRef.current?.getValue();
        if (question.is_required && !value) {
            if (e) inputRef.current?.setError(lang.linkEmp);
            return false;
        }
        if (value && !urlValidation(value)) {
            if (e) inputRef.current?.setError(lang.linkErr);
            return false;
        }
        return true;
    }

    function setAnswer() {
        const value = inputRef.current?.getValue();
        const data = [...props.answerList];
        if (value && validate()) {
            const response: AnswerItem = {
                value: value,
                answer: props.answer?.id,
                question: props.question,
                id: new Date().getTime(),
            };
            index !== undefined && index > -1 && data ? (data[index] = response) : data.push(response);
        } else if (index !== undefined && index > -1) data.splice(index, 1);
        props.setAnswerList(data);
    }

    function onSubmit(e?: boolean) {
        const value = inputRef.current?.getValue();
        if ((value || props.answerList?.find((i) => i.id === question.id)?.value) && validate(e) && props.answer)
            props.submit({
                value: value,
                question: question,
                id: new Date().getTime(),
                created_at: new Date().toISOString(),
            });
    }

    return (
        <SLPInputUrl
            color={props.form?.answer_color}
            labelColor={props.form?.question_color}
            hint={extractTitle(hint, false, false)}
            ref={inputRef}
            counter={props.counter}
            label={extractTitle(title, false, false)}
            image={question.image_file}
            required={question.is_required}
            onChange={setAnswer}
            onEnter={() => {
                if (props.form.show_type === FormShowType.single) props.next();
            }}
            dir={props.form.direction}
            defaultValue={
                index !== undefined && index > -1 && props.answerList[index].value
                    ? props.answerList[index].value
                    : undefined
            }
            endIcon={getQuestionBadge(QuestionTypes.website)}
        />
    );
};
const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
    lang: state.lang,
});

const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPWebsiteQuestion));
